import { render, staticRenderFns } from "./UserPermissionDialog.vue?vue&type=template&id=1a728b4c"
import script from "./UserPermissionDialog.vue?vue&type=script&lang=js"
export * from "./UserPermissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports